import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { configurarAvisoCadastroIncompleto } from '../../services/api';
import usePermissao from './usePermissao';

export const ESPERA_AVISO_MS = 30000;

/**
 * Movimentação recusada porque o cadastro veio do sistema anterior sem dado obrigatório (422 CADASTRO_INCOMPLETO;
 * 4clinics_backend/docs/importacao-planilhas.md, I7). Vale para qualquer tela (agenda, pacotes): mostra o motivo e,
 * para quem altera pacientes, o botão "Completar cadastro", que abre o cadastro e, depois de salvar, volta para a tela de origem
 * (P-Q8: motivo + o que fazer + ação). A tela que chamou continua recebendo o erro e mostrando a mensagem dela.
 */
export default function AvisoCadastroIncompleto() {
  const [recusa, setRecusa] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { podeAlterar } = usePermissao('pacientes');

  useEffect(() => {
    configurarAvisoCadastroIncompleto((r) => setRecusa(r));
    return () => configurarAvisoCadastroIncompleto(null);
  }, []);

  const fechar = () => setRecusa(null);
  const completar = () => {
    const rota = recusa?.rota;
    setRecusa(null);
    if (rota) navigate(rota, { state: { voltarPara: `${location.pathname}${location.search}` } });
  };

  return (
    <Snackbar
      open={Boolean(recusa)}
      autoHideDuration={ESPERA_AVISO_MS}
      onClose={(_, motivo) => motivo !== 'clickaway' && fechar()}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        variant="filled"
        data-testid="aviso-cadastro-incompleto"
        sx={{ width: '100%', alignItems: 'center' }}
        action={(
          <>
            {podeAlterar && recusa?.rota && (
              <Button color="inherit" size="small" onClick={completar} data-testid="aviso-cadastro-incompleto-completar">
                Completar cadastro
              </Button>
            )}
            <IconButton color="inherit" size="small" aria-label="Fechar" onClick={fechar}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        )}
      >
        {recusa?.mensagem}
        {recusa && !podeAlterar && ' Peça a quem cadastra pacientes para completar.'}
      </Alert>
    </Snackbar>
  );
}
